import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b465d6fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "empty" }, "見つかりませんでした。", -1))
const _hoisted_5 = [
  _hoisted_4
]

import { ref, onMounted, onUnmounted } from "vue";
import { adService } from "@/app/services/AdService";
import router from "@/router";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import Header from "@/components/organisms/common/Header.vue";
import { useRoute } from "vue-router";
import { useLoader } from "@/utils/loader";
import { useErrorModal } from "@/utils/modal";
import { DisplayDetail } from "@/types/ad/DisplayDetail";


export default /*#__PURE__*/_defineComponent({
  __name: 'Detail',
  setup(__props) {

const route = useRoute();
const loader = useLoader();
const errorModal = useErrorModal();

const ad = ref<DisplayDetail | null>(null);

const handleAdClickEvent = (event: Event) => {
  if (ad.value) {
    adService.handleAdClickEvent(event, ad.value.id);
  }
};

onMounted(async () => {
  try {
    loader.show();
    const adId = Number(route.params.adId);
    const displayDetail = await adService.displayDetail(adId);
    if (displayDetail) {
      ad.value = displayDetail;

      // 表示イベントを送信（await しない）
      adService.registerEvent(displayDetail.id, "view_detail");

      // 表示後のイベントを受信するためのリスナーを登録
      window.removeEventListener("click", handleAdClickEvent);
      window.addEventListener("click", handleAdClickEvent);
    }
  } catch (e) {
    await errorModal.showErrorModal(e as Error);
  } finally {
    loader.hide();
  }
});

onUnmounted(() => {
  window.removeEventListener("click", handleAdClickEvent);
});

function onClickBack() {
  router.back();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Header, null, {
      left: _withCtx(() => [
        _createVNode(FeatherIcon, {
          icon: "chevron-left",
          onClick: onClickBack
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      詳細\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    (ad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            innerHTML: ad.value.html
          }, null, 8, _hoisted_2)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
  ]))
}
}

})